<template>
  <div class="app-container">
    <el-card>
      <div class="filter-container">
        <el-input v-model="query.ticket_number" placeholder="准考证号" clearable style="width:200px;" class="filter-item"/>
        <el-input v-model="query.username" placeholder="姓名" clearable style="width:200px;" class="filter-item"/>
        <el-select v-model="query.session_id" placeholder="招聘场次" clearable style="width:200px;" class="filter-item" @change="handleSessionChange">
          <el-option
            v-for="item in sessionOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
        <!-- <el-select v-model="query.company_id" placeholder="招聘单位" clearable style="width:200px;" class="filter-item" >
          <el-option
            v-for="item in companyOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
        <!-- <el-select v-model="query.position_id" placeholder="招聘职位" clearable style="width:200px;" class="filter-item" :disabled="!query.session_id">
          <el-option
            v-for="item in positionOptions"
            :key="item.id"
            :label="item.position_name"
            :value="item.id">
          </el-option>
        </el-select> -->
        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <!-- <el-button type="danger" icon="el-icon-delete" :disabled="!multipleSelection.length" @click="handleBatchDelete">批量删除</el-button> -->
        <!-- <el-button icon="el-icon-download" @click="handleExport">导出</el-button> -->
      </div>
      <el-table :data="list" border v-loading="loading" style="margin-top:20px;" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column prop="id" label="ID" width="60" align="center" >
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="ticket_number" label="准考证号" width="120"/>
        <el-table-column prop="name" label="用户姓名" width="80" align="center" />
        <el-table-column prop="company_name" label="报考单位" width="280" align="center" />
        <el-table-column prop="position_name" label="报考职位" width="150" align="center" />
        <!-- <el-table-column prop="exam_id" label="考试ID" width="80" align="center" /> -->
        <el-table-column prop="exam_room" label="考场" width="180" align="center" />
        <el-table-column prop="exam_name" label="考试科目" width="180" align="center" />
        <el-table-column prop="seat_number" label="座位号" width="80" align="center" />
        <el-table-column prop="exam_time" label="考试时间"align="center" />
        <!-- <el-table-column prop="notes" label="备注" /> -->
        <el-table-column prop="createtime" label="创建时间" width="160" />
        <!-- <el-table-column label="操作" width="180" align="center">
          <template slot-scope="{row}">
            <el-button type="success" size="mini" @click="handleToggleStatus(row)">
              {{ row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50]"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { getAdmissionTicketList, deleteAdmissionTicket, batchDeleteAdmissionTicket, updateAdmissionTicketStatus, exportAdmissionTicket } from '@/api/exam'
import { getAllSessionList } from '@/api/recruitment-session'
import { getAllPositionList } from '@/api/recruitment-position'
import { getAllCompanyList } from '@/api/recruitment-company'
export default {
  name: 'AdmissionTicketsList',
  data() {
    return {
      query: {
        page: 1,
        limit: 20,
        ticket_number: '',
        session_id: '',
        position_id: '',
        company_id: '',
        username: ''
      },
      list: [],
      total: 0,
      loading: false,
      multipleSelection: [],
      sessionOptions: [],
      positionOptions: [],
      companyOptions: []
    }
  },
  created() {
    this.getSessionList()
    this.getCompanyList(0)
    this.getList()
  },
  methods: {
    async getSessionList() {
      try {
        await getAllSessionList().then(res => {
          this.sessionOptions = res.data.list
        })
      } catch (error) {
        console.error('获取招聘场次列表失败:', error)
      }
    },
    async handleSessionChange(sessionId) {
      this.query.company_id = ''
      this.companyOptions = []
      this.query.position_id = ''
      this.positionOptions = []
      if (sessionId) {
        await this.getCompanyList(sessionId)
        try {
          await getAllPositionList({ session_id: sessionId }).then(res => {
            this.positionOptions = res.data.list
          })
        } catch (error) {
          console.error('获取职位列表失败:', error)
        }
      }
    },
    async getCompanyList(session_id) {
      try {
        await getAllCompanyList({ session_id: session_id }).then(res => {
          this.companyOptions = res.data.list
        })
      } catch (error) {
        console.error('获取单位列表失败:', error)
      }
    },
    async getList() {
      this.loading = true
      try {
        // 模拟接口调用
        const res = await getAdmissionTicketList(this.query).then(res => {
          this.list = res.data.list
          this.total = res.data.total
        });
        
      } catch (e) {
        this.list = []
        this.total = 0
      }
      this.loading = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.query.limit = val
      this.getList()
    },
    handleReset() {
      this.query = {
        page: 1,
        limit: 20,
        ticket_number: '',
        session_id: '',
        position_id: '',
        company_id: '',
        username: ''
      }
      this.positionOptions = []
      this.getList()
    },
    handleBatchDelete() {
      this.$confirm('确定批量删除选中的准考证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 模拟删除
        const ids = this.multipleSelection.map(item => item.id)
        this.mockList = this.mockList.filter(item => !ids.includes(item.id))
        this.$message.success('批量删除成功')
        this.getList()
      })
    },
    async handleDelete(row) {
      this.$confirm('确定删除该准考证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 模拟删除
        this.mockList = this.mockList.filter(item => item.id !== row.id)
        this.$message.success('删除成功')
        this.getList()
      })
    },
    async handleToggleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      try {
        // 模拟状态更新
        const index = this.mockList.findIndex(item => item.id === row.id)
        if (index !== -1) {
          this.mockList[index].status = newStatus
        }
        this.$message.success('状态已更新')
        this.getList()
      } catch (e) {
        this.$message.error('状态更新失败')
      }
    },
    async handleExport() {
      this.$message.success('导出功能开发中...')
    }
  }
}
</script>
<style scoped>
.filter-container { margin-bottom: 20px; }
.pagination-container { margin-top: 20px; text-align: right; }
</style> 


// WEBPACK FOOTER //
// src/views/exam/AdmissionTicketsList.vue